import { snakeToCamel } from '../CaseUtils';

export const ActiveOrdersETL = (response) =>
  (response?.results || []).map((o) => ({
    id: o.id,
    displayId: o.display_id,
    orderStatusId: o.order_status_id,
    orderStatusName: o.order_status_name,
    orderType: o.order_type,
    businessId: o.business_id,
    tipSummary: snakeToCamel(o.tip_summary),
    restaurantName: o.restaurant_name,
    restaurantLat: o.restaurant_lat,
    restaurantLon: o.restaurant_lon,
    pickupAt: o.pickup_at || null,
    driverUserId: o.dispatch?.driver_user_id ?? null,
  }));
